module.exports = "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAAEsAQMAAABDsxw2AAAAA1BMVEW9xs6LgM/mAAAAAXRSTlOArV5bRgAAACJJREFUaN7twTEBAAAAwiD7pzbFPmAAAAAAAAAAAAAAAGQOLbQAAU3zwM4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/a3.jpg
// module id = h4De
// module chunks = 1